// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if ("serviceWorker" in navigator && "PushManager" in window) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(window._env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener("load", () => {
      // const swUrl = `${window._env.PUBLIC_URL}/service-worker.js`;

      const swFileName =
        window._env.NODE_ENV === "production"
          ? "service-worker.js"
          : "custom-sw.js";
      const swUrl = `${window._env.PUBLIC_URL}/${swFileName}`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service " +
              "worker. To learn more, visit https://bit.ly/CRA-PWA"
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

async function registerValidSW(swUrl, config) {

  try{
      // Registering Service Worker
      //  const registration = await navigator.serviceWorker.register(swUrl);
      await navigator.serviceWorker.register(swUrl);
      //  if (!registration.pushManager) {
      //    console.log("Push manager unavailable.");
      //    return;
      //  }

      //  const existingSubscription = await registration.pushManager.getSubscription();

      //  if (existingSubscription === null){
      //    const subscription = await registration.pushManager.subscribe({
      //      applicationServerKey: urlBase64ToUint8Array(
      //        window._env.REACT_APP_PUBLIC_VAPID_KEY
      //      ),
      //      userVisibleOnly: true
      //    });
      //    await sendSubscription(subscription);
      //  }
      //  else{
      //    await sendSubscription(existingSubscription);
      //  }
     }
     catch(err){
      console.error("An error ocurred during the subscription process.", err);
      //  if (Notification.permission !== "granted") {
      //    console.log("Permission was not granted.");
      //  } else {
      //    console.error("An error ocurred during the subscription process.", err);
      //  }
  }
}

// function sendSubscription(subscription) {
//   console.log("subsccription:", JSON.stringify(subscription));
//   return fetch(
//     `${window._env.REACT_APP_EMCONSOLE_API_URL}/notifications/subscribe`,
//     {
//       method: "POST",
//       body: JSON.stringify(subscription),
//       headers: {
//         "Content-Type": "application/json"
//       }
//     }
//   );
// }

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}


// function urlBase64ToUint8Array(base64String) {
//   const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
//   // eslint-disable-next-line
//   const base64 = (base64String + padding)
//     .replace(/\-/g, "+")
//     .replace(/_/g, "/");

//   const rawData = window.atob(base64);
//   const outputArray = new Uint8Array(rawData.length);

//   for (let i = 0; i < rawData.length; ++i) {
//     outputArray[i] = rawData.charCodeAt(i);
//   }
//   return outputArray;
// }
